export default {
    list: {
        name: "community building list api",
        version: 6,
        url: "community/%{community_id}/buildings",
        method: "GET",
    },
    add: {
        name: "add community building api",
        version: 6,
        url: "community/%{community_id}/buildings",
        method: "POST",
    },
    update: {
        name: "update community building api",
        version: 6,
        url: "community/%{community_id}/buildings/%{id}",
        method: "PUT",
    },
    delete: {
        name: "delete community building api",
        version: 6,
        url: "community/%{community_id}/buildings/%{id}",
        method: "DELETE",
    },
};
